interface SVGProps {
  style: React.CSSProperties;
  color: string;
}

const SVG = (props: SVGProps) => {
  const { color } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M8 6.44995L11.4 8.99996L8 11.55V6.44995Z" fill="black" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0649 5.5C12.1125 4.15509 10.6755 3.4 9 3.4C5.90721 3.4 3.4 5.90721 3.4 9H2C2 5.13401 5.13401 2 9 2C10.963 2 12.6924 2.82776 13.9 4.28924V3.4H15.3V6.9H11.8V5.5H13.0649Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.93534 12.5C5.88767 13.8449 7.32466 14.6 9.0002 14.6C12.093 14.6 14.6002 12.0928 14.6002 9H16.0002C16.0002 12.866 12.8662 16 9.0002 16C7.03723 16 5.30777 15.1722 4.1002 13.7108V14.6H2.7002L2.7002 11.1H6.2002V12.5H4.93534Z"
        fill={color}
      />
    </svg>
  );
};

export default SVG;
